import { useSelector } from "react-redux";
import type { FlightExchangeTripDetailsCardProps } from "@b2bportal/core-flights";
import { FlightPostBookingSelectors } from "../../../postbooking/store";
import { FlightShopSelectors } from "../../../shop/store";
import {
  getOutboundChanged,
  getReturnChanged,
} from "../../store/searchSelectors";
import { getOutboundSlice, getReturnSlice } from "../../store/shopSelectors";

export const useFlightExchangeTripDetailsCard = (
  props: FlightExchangeTripDetailsCardProps
) => {
  const outboundSlice = useSelector(getOutboundSlice);
  const outboundChanged = useSelector(getOutboundChanged);
  const returnSlice = useSelector(getReturnSlice);
  const returnChanged = useSelector(getReturnChanged);

  const postBookingAirportMap = useSelector(
    FlightPostBookingSelectors.getAirports
  );
  const shopAirportMap = useSelector(FlightShopSelectors.getAirports);

  const updatedItinerary = useSelector(
    FlightPostBookingSelectors.getSelectedFlightItinerary
  )?.data;

  return {
    copy: {},
    context: {
      slices: {
        outbound: outboundSlice,
        outboundChanged,
        return: returnSlice,
        returnChanged,
      },
      airportMap: {
        ...postBookingAirportMap,
        ...shopAirportMap,
      },
      updatedItinerary,
      updateBadgeCopyOverride: props.updateBadgeCopyOverride,
    },
    handlers: {},
  };
};
